import styled from 'styled-components';

import { Title } from '@/components/Typography';

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.5rem;
	padding: 0.5rem 0.5rem 0;
`;

export const Body = styled.p`
	margin: 0;
	text-align: center;
	font-size: 1.125rem;
	line-height: 1.5rem;
	color: #262626;
`;

export const Footer = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
`;

export const ModalTitle = styled(Title)`
	margin: 0;
	text-align: center;
`;
